export const heroSlides = [
  {
    id: 1,
    tag: '全方位 · 全周期整合型健康服务平台',
    title: '中西医结合智慧生态平台',
    subtitle: '以数智化转型、中西医协同为牵引，打造面向政府、医院、基层机构、医师、患者与产业合作方的全国性智慧生态服务门户。',
    primaryText: '进入平台',
    primaryHref: '#courses',
    secondaryText: '了解平台',
    secondaryHref: '#intro',
    image:
      'https://readdy.ai/api/search-image?query=Elegant%20abstract%20background%20blending%20traditional%20Chinese%20medicine%20aesthetics%20with%20modern%20digital%20technology%2C%20flowing%20crimson%20red%20and%20jade%20green%20ink%20brush%20strokes%20merging%20into%20luminous%20data%20network%20lines%2C%20herbal%20leaves%20and%20circuit%20patterns%2C%20warm%20ivory%20canvas%2C%20cinematic%20soft%20lighting%2C%20strong%20dark%20contrast%20in%20lower%20area%2C%20artistic%20minimal%20composition&width=1920&height=1080&seq=hero-tcm-2026-a&orientation=landscape',
  },
  {
    id: 2,
    tag: '中西医协同 · 传承创新',
    title: '传承国医精髓，汇聚数智动能',
    subtitle: '中医辨证智慧与循证医学在这里交汇，让名老中医的经验可沉淀、可传承、可服务于更多医师与患者。',
    primaryText: '名师好课',
    primaryHref: '#courses',
    secondaryText: '医师团队',
    secondaryHref: '#doctors',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20artistic%20composition%20symbolizing%20integrated%20Chinese%20and%20Western%20medicine%2C%20geometric%20hexagon%20molecule%20structures%20intertwining%20with%20ink%20wash%20bamboo%20and%20ginseng%20roots%2C%20deep%20crimson%20and%20dark%20teal%20tones%20on%20warm%20neutral%20background%2C%20soft%20cinematic%20gradient%2C%20generous%20negative%20space%20in%20lower%20area%2C%20elegant%20modern%20poster%20style&width=1920&height=1080&seq=hero-tcm-2026-b&orientation=landscape',
  },
  {
    id: 3,
    tag: '全国性 · 智慧生态服务门户',
    title: '一体化服务，贯通医教研产',
    subtitle: '连接课程、活动、视频、医师与产业伙伴，构建开放共享的中西医结合智慧生态。',
    primaryText: '生态合作',
    primaryHref: '#contact',
    secondaryText: '活动动态',
    secondaryHref: '#activities',
    image:
      'https://readdy.ai/api/search-image?query=Futuristic%20yet%20traditional%20medical%20ecosystem%20visualization%2C%20glowing%20data%20grid%20converging%20with%20calligraphy%20brush%20texture%20and%20meridian%20acupuncture%20point%20lines%2C%20warm%20red%20and%20gold%20accents%20over%20dark%20charcoal%2C%20soft%20bokeh%20particles%2C%20layered%20depth%2C%20sophisticated%20minimal%20design%20with%20empty%20lower%20zone%20for%20headline%20text&width=1920&height=1080&seq=hero-tcm-2026-c&orientation=landscape',
  },
];

export const stats = [
  { id: 1, icon: 'ri-book-2-line', value: 2922, suffix: '+', unit: '', label: '精品课程' },
  { id: 2, icon: 'ri-community-line', value: 3004, suffix: '+', unit: '', label: '基层医联体' },
  { id: 3, icon: 'ri-stethoscope-line', value: 5207, suffix: '+', unit: '', label: '医师专家团队' },
  { id: 4, icon: 'ri-group-line', value: 8200, suffix: '万+', unit: '', label: '年度覆盖人次' },
];

export const introHighlights = [
  {
    id: 1,
    icon: 'ri-cpu-line',
    title: '数智化转型',
    desc: '以数据中台与智能技术为底座，驱动服务、教学与运营的全流程数字化升级，让每一个环节都更高效、更精准。',
  },
  {
    id: 2,
    icon: 'ri-heart-pulse-line',
    title: '中西医协同',
    desc: '让辨证论治的东方智慧与循证医学的科学方法在同一平台协同发力，形成优势互补的诊疗与服务范式。',
  },
  {
    id: 3,
    icon: 'ri-loop-right-line',
    title: '全周期服务',
    desc: '覆盖预防、诊疗、康复、养生的全生命周期健康服务，实现从"治已病"到"治未病"的连续照护。',
  },
  {
    id: 4,
    icon: 'ri-book-marked-line',
    title: '国医名师数字化传承',
    desc: '以数字化手段完整留存名医的诊疗经验与学术思想，让宝贵的临床智慧实现代际传承与广泛共享。',
  },
  {
    id: 5,
    icon: 'ri-line-chart-line',
    title: '真实世界研究',
    desc: '依托真实世界数据开展中医药循证研究，用真实数据还原临床疗效，让每一项结论都有据可依。',
  },
  {
    id: 6,
    icon: 'ri-database-2-line',
    title: '数据一体化服务',
    desc: '提供从"海量冷数据长期归档底座、清洗治理、科研转化、应用开发、到数据资产入表"的一站式服务包。',
  },
];

/** 平台介绍区块（标题/正文/配图/平台定位卡片） */
export const platformIntro = {
  title: '以中西医协同为牵引，构建全国健康智慧生态服务门户',
  paragraphs: [
    '中西医结合智慧生态平台围绕《国民健康"十五五"规划》"以数智化转型与中西医协同为牵引"为战略导向，以全球领先的数据基座及算法模型为底层技术支撑，践行"标准筑基、数智赋能、生态融合、服务民生"理念，汇聚名医名科名院、科研院校、产业伙伴等优质资源，构建起覆盖学习-临床-科研-协作-转化-应用-推广-服务-数据-治理-开发-入表的完整服务链条。',
    '面向政府、医院、基层、医师、患者及产业合作方，提供一站式整合型健康服务，旨在通过系统性中西医结合服务生态，让辨证论治的东方智慧与循证医学的科学方法在同一平台上协同发力，推动中医药在传承中创新、在创新中发展。',
  ],
  image:
    'https://readdy.ai/api/search-image?query=Artistic%20scene%20blending%20traditional%20Chinese%20medicine%20and%20digital%20health%20technology%2C%20dried%20herbs%20and%20a%20ceramic%20mortar%20beside%20a%20glowing%20semi%20transparent%20data%20interface%2C%20warm%20ivory%20and%20crimson%20tones%2C%20soft%20studio%20lighting%2C%20elegant%20minimal%20editorial%20photography%2C%20high%20detail%20harmonious%20composition&width=900&height=1100&seq=intro-tcm-2026&orientation=portrait',
  positionIcon: 'ri-shield-star-line',
  positionLabel: '平台定位',
  positionText: '全方位全周期\n整合型健康服务平台',
};

export const courses = [
  {
    id: 1,
    title: '中医传承·国药大师中医调理课程系列',
    category: '快速攻略',
    doctor: '李显筑',
    lessons: 12,
    price: 199,
    image:
      'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20medicine%20course%20cover%2C%20neatly%20arranged%20ancient%20herbal%20medicine%20books%20with%20dried%20herbs%20and%20a%20mortar%20and%20pestle%2C%20clean%20warm%20ivory%20background%2C%20soft%20natural%20studio%20light%2C%20elegant%20minimal%20editorial%20photography%2C%20high%20detail%2C%20harmonious%20warm%20tones&width=680&height=424&seq=course-tcm-01&orientation=landscape',
  },
  {
    id: 2,
    title: '中西医结合内科临床进阶课',
    category: '临床提升',
    doctor: '胡晓峰',
    lessons: 18,
    price: 299,
    image:
      'https://readdy.ai/api/search-image?query=Modern%20integrated%20Chinese%20Western%20medicine%20course%20cover%2C%20a%20stethoscope%20resting%20beside%20a%20bowl%20of%20dried%20Chinese%20herbs%20on%20a%20clean%20light%20beige%20surface%2C%20soft%20diffused%20studio%20lighting%2C%20minimal%20editorial%20style%2C%20warm%20neutral%20background%2C%20high%20detail&width=680&height=424&seq=course-tcm-02&orientation=landscape',
  },
  {
    id: 3,
    title: '八段锦与经络养生实操课',
    category: '养生功法',
    doctor: '黄涛',
    lessons: 8,
    price: 129,
    image:
      'https://readdy.ai/api/search-image?query=Baduanjin%20qigong%20health%20course%20cover%2C%20a%20rolled%20bamboo%20scroll%20with%20a%20soft%20green%20tea%20cup%20and%20delicate%20leafy%20branch%2C%20warm%20cream%20background%2C%20gentle%20morning%20light%2C%20minimal%20oriental%20editorial%20photography%2C%20calm%20harmonious%20mood&width=680&height=424&seq=course-tcm-03&orientation=landscape',
  },
  {
    id: 4,
    title: '针灸推拿基础与临床应用',
    category: '技法精讲',
    doctor: '沈潜',
    lessons: 24,
    price: 359,
    image:
      'https://readdy.ai/api/search-image?query=Acupuncture%20and%20tuina%20course%20cover%2C%20fine%20acupuncture%20needles%20placed%20beside%20ginger%20slices%20and%20a%20small%20ceramic%20dish%2C%20smooth%20ivory%20background%2C%20soft%20elegant%20studio%20light%2C%20minimal%20traditional%20medicine%20editorial%20photography%2C%20warm%20crisp%20detail&width=680&height=424&seq=course-tcm-04&orientation=landscape',
  },
  {
    id: 5,
    title: '中医四诊合参实战：望闻问切全流程',
    category: '快速攻略',
    doctor: '黄涛',
    lessons: 10,
    price: 169,
    image:
      'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20medicine%20four%20diagnostic%20methods%20course%20cover%2C%20a%20doctor%20hand%20resting%20on%20a%20pulse%20diagnosis%20cushion%20beside%20an%20open%20notebook%20and%20dried%20herbs%2C%20clean%20warm%20ivory%20background%2C%20soft%20studio%20light%2C%20minimal%20editorial%20photography%2C%20high%20detail&width=680&height=424&seq=course-tcm-05&orientation=landscape',
  },
  {
    id: 6,
    title: '《伤寒论》经方临证运用精讲',
    category: '临床提升',
    doctor: '李显筑',
    lessons: 20,
    price: 329,
    image:
      'https://readdy.ai/api/search-image?query=Classical%20Chinese%20medicine%20formula%20course%20cover%2C%20an%20open%20ancient%20thread%20bound%20medical%20book%20with%20a%20calligraphy%20brush%20and%20a%20small%20ceramic%20herb%20bowl%2C%20warm%20cream%20background%2C%20soft%20elegant%20studio%20light%2C%20minimal%20oriental%20editorial%20photography%2C%20high%20detail&width=680&height=424&seq=course-tcm-06&orientation=landscape',
  },
  {
    id: 7,
    title: '二十四节气养生与体质调摄',
    category: '养生功法',
    doctor: '黄涛',
    lessons: 9,
    price: 149,
    image:
      'https://readdy.ai/api/search-image?query=Seasonal%20health%20cultivation%20course%20cover%2C%20a%20round%20bamboo%20mat%20with%20seasonal%20fruits%2C%20a%20small%20tea%20cup%20and%20fresh%20green%20leaves%20arranged%20neatly%2C%20warm%20neutral%20background%2C%20soft%20natural%20light%2C%20minimal%20oriental%20editorial%20photography%2C%20high%20detail&width=680&height=424&seq=course-tcm-07&orientation=landscape',
  },
  {
    id: 8,
    title: '艾灸与拔罐适宜技术实操课',
    category: '技法精讲',
    doctor: '沈潜',
    lessons: 16,
    price: 269,
    image:
      'https://readdy.ai/api/search-image?query=Moxibustion%20and%20cupping%20therapy%20course%20cover%2C%20a%20moxa%20stick%20and%20several%20glass%20cupping%20jars%20resting%20on%20a%20clean%20linen%20cloth%2C%20warm%20ivory%20background%2C%20soft%20studio%20light%2C%20minimal%20traditional%20medicine%20editorial%20photography%2C%20high%20detail&width=680&height=424&seq=course-tcm-08&orientation=landscape',
  },
  {
    id: 9,
    title: '脾胃病辨证论治临床精要',
    category: '临床提升',
    doctor: '胡晓峰',
    lessons: 15,
    price: 259,
    image:
      'https://readdy.ai/api/search-image?query=Digestive%20health%20course%20cover%2C%20a%20bowl%20of%20warm%20herbal%20congee%20with%20red%20dates%20and%20a%20ceramic%20spoon%20on%20a%20light%20wooden%20table%2C%20clean%20beige%20background%2C%20soft%20natural%20light%2C%20minimal%20wellness%20editorial%20photography%2C%20high%20detail&width=680&height=424&seq=course-tcm-09&orientation=landscape',
  },
  {
    id: 10,
    title: '情志调养与中医心理疏导',
    category: '养生功法',
    doctor: '沈潜',
    lessons: 7,
    price: 119,
    image:
      'https://readdy.ai/api/search-image?query=Emotional%20wellness%20course%20cover%2C%20a%20cup%20of%20herbal%20tea%20beside%20a%20small%20green%20plant%20and%20a%20soft%20folded%20cloth%20on%20a%20clean%20cream%20surface%2C%20calm%20peaceful%20mood%2C%20soft%20light%2C%20minimal%20editorial%20photography%2C%20high%20detail&width=680&height=424&seq=course-tcm-10&orientation=landscape',
  },
];

export const trainingEvents = [
  {
    id: 1,
    year: 2026,
    type: '研修班',
    topic: '中西结合治疗糖尿病并发症专题研修班',
    hospital: '河北省沧州中西医结合医院',
    date: '2026.12.12',
    time: '09:00 - 17:00',
    enrolled: 28,
    capacity: 60,
    signFee: 1280,
    speakers: ['李显筑', '赵家军', '杨晓晖'],
    image:
      'https://readdy.ai/api/search-image?query=Chinese%20medicine%20continuing%20education%20lecture%20hall%20with%20rows%20of%20physician%20attendees%20and%20a%20speaker%20on%20stage%2C%20warm%20wooden%20interior%2C%20soft%20natural%20light%2C%20professional%20editorial%20photography%2C%20calm%20harmonious%20atmosphere&width=520&height=340&seq=act-hall-01&orientation=landscape',
  },
  {
    id: 2,
    year: 2026,
    type: '精研班',
    topic: '中西医结合脑病国医大师精研班',
    hospital: '北京中医药大学东方医院',
    date: '2026.12.16',
    time: '09:00 - 17:00',
    enrolled: 45,
    capacity: 50,
    signFee: 2980,
    speakers: ['王新陆', '王中琳', '齐向华'],
    image:
      'https://readdy.ai/api/search-image?query=Senior%20Chinese%20medicine%20master%20teaching%20apprentices%20around%20a%20table%20with%20ancient%20medical%20texts%20and%20dried%20herbs%2C%20warm%20neutral%20room%2C%20soft%20window%20light%2C%20respectful%20documentary%20photography&width=520&height=340&seq=act-master-02&orientation=landscape',
  },
  {
    id: 3,
    year: 2027,
    type: '精研班',
    topic: '中西结合治疗脾胃病国医大师精研班',
    hospital: '河北省中医院',
    date: '2027.01.20',
    time: '09:00 - 17:00',
    enrolled: 32,
    capacity: 50,
    signFee: 2980,
    speakers: ['李佃贵', '杨晋翔', '刘汶'],
    image:
      'https://readdy.ai/api/search-image?query=Integrated%20Chinese%20and%20Western%20medicine%20seminar%20roundtable%20with%20doctors%20discussing%20around%20a%20table%2C%20warm%20beige%20interior%2C%20soft%20window%20light%2C%20professional%20editorial%20photography&width=520&height=340&seq=act-seminar-04&orientation=landscape',
  },
  {
    id: 4,
    year: 2027,
    type: '研修班',
    topic: '现代医疗中西医结合管理能力提升高级研修班',
    hospital: '北京大学',
    date: '2027.03.13',
    time: '09:30 - 16:00',
    enrolled: 66,
    capacity: 80,
    signFee: 0,
    speakers: ['韩晶岩'],
    image:
      'https://readdy.ai/api/search-image?query=Medical%20training%20classroom%20with%20physicians%20taking%20notes%20and%20a%20teacher%20demonstrating%20herbal%20medicine%2C%20warm%20bright%20interior%2C%20soft%20natural%20light%2C%20editorial%20photography&width=520&height=340&seq=act-practice-05&orientation=landscape',
  },
];

export const videos = [
  {
    id: 1,
    title: '《解读中医》王新陆 山东中医药大学（高清全集）',
    category: '国医讲堂',
    doctor: '王新陆',
    views: '3.6万',
    duration: '42:18',
    image:
      'https://readdy.ai/api/search-image?query=Video%20thumbnail%20about%20interpreting%20traditional%20Chinese%20medicine%2C%20a%20stack%20of%20classic%20Chinese%20medical%20books%20with%20a%20calligraphy%20brush%20and%20a%20stone%20seal%20on%20a%20warm%20wooden%20desk%2C%20soft%20golden%20studio%20light%2C%20elegant%20documentary%20still%2C%20high%20detail&width=640&height=360&seq=video-yy-01&orientation=landscape',
  },
  {
    id: 2,
    title: '国医大师王新陆：师承教育是中医的终身教育模式',
    category: '国医讲堂',
    doctor: '王新陆',
    views: '2.1万',
    duration: '18:42',
    image:
      'https://readdy.ai/api/search-image?query=Video%20thumbnail%20of%20a%20master%20apprentice%20teaching%20scene%20in%20traditional%20Chinese%20medicine%2C%20a%20senior%20Chinese%20doctor%20explaining%20classical%20medical%20texts%20to%20young%20students%20around%20a%20wooden%20table%2C%20warm%20neutral%20room%2C%20soft%20window%20light%2C%20respectful%20documentary%20still%2C%20high%20detail&width=640&height=360&seq=video-yy-02&orientation=landscape',
  },
  {
    id: 3,
    title: '04、《王新陆 解读中医》：中西之路',
    category: '国医讲堂',
    doctor: '王新陆',
    views: '1.4万',
    duration: '26:05',
    image:
      'https://readdy.ai/api/search-image?query=Video%20thumbnail%20symbolizing%20the%20path%20between%20Chinese%20and%20Western%20medicine%2C%20a%20stethoscope%20resting%20beside%20herbal%20medicine%20and%20an%20open%20medical%20text%20on%20a%20clean%20light%20surface%2C%20warm%20soft%20light%2C%20conceptual%20documentary%20still%2C%20high%20detail&width=640&height=360&seq=video-yy-03&orientation=landscape',
  },
  {
    id: 4,
    title: '时任山东中医药大学校长王新陆：中西医结合是…',
    category: '国医讲堂',
    doctor: '王新陆',
    views: '1.9万',
    duration: '21:30',
    image:
      'https://readdy.ai/api/search-image?query=Video%20thumbnail%20of%20a%20Chinese%20medicine%20university%20lecture%20hall%2C%20a%20distinguished%20doctor%20speaking%20at%20a%20podium%20to%20attentive%20students%2C%20warm%20wooden%20interior%2C%20soft%20natural%20light%2C%20professional%20documentary%20still%2C%20high%20detail&width=640&height=360&seq=video-yy-04&orientation=landscape',
  },
  {
    id: 5,
    title: '"脉诊传奇" 齐向华给祝绪丹诊脉，竟然看出膝…',
    category: '临证精讲',
    doctor: '齐向华',
    views: '2.8万',
    duration: '12:56',
    image:
      'https://readdy.ai/api/search-image?query=Video%20thumbnail%20of%20traditional%20Chinese%20pulse%20diagnosis%2C%20a%20doctor%20gently%20placing%20three%20fingers%20on%20a%20patient%20wrist%20to%20feel%20the%20pulse%2C%20warm%20neutral%20clinic%2C%20soft%20light%2C%20calm%20documentary%20still%2C%20high%20detail&width=640&height=360&seq=video-yy-05&orientation=landscape',
  },
  {
    id: 6,
    title: '秋天是金形人的难关！这几类不适最容易找上门',
    category: '养生有道',
    doctor: '节气养生',
    views: '8760',
    duration: '09:24',
    image:
      'https://readdy.ai/api/search-image?query=Video%20thumbnail%20about%20autumn%20health%20cultivation%20in%20traditional%20Chinese%20medicine%2C%20warm%20golden%20autumn%20leaves%2C%20a%20cup%20of%20herbal%20tea%20and%20pears%20on%20a%20wooden%20table%2C%20soft%20afternoon%20light%2C%20serene%20oriental%20wellness%20still%2C%20high%20detail&width=640&height=360&seq=video-yy-06&orientation=landscape',
  },
  {
    id: 7,
    title: '瑞隆安糖尿病1357峰会 李显筑教授讲授关注糖尿…',
    category: '临证精讲',
    doctor: '李显筑',
    views: '1.1万',
    duration: '32:40',
    image:
      'https://readdy.ai/api/search-image?query=Video%20thumbnail%20of%20a%20diabetes%20medical%20summit%2C%20a%20doctor%20presenting%20on%20a%20stage%20with%20a%20large%20screen%20showing%20health%20data%2C%20warm%20modern%20conference%20hall%2C%20soft%20ambient%20light%2C%20professional%20event%20still%2C%20high%20detail&width=640&height=360&seq=video-yy-07&orientation=landscape',
  },
  {
    id: 8,
    title: '李显筑：气血亏虚导致的头晕、健忘、胸闷、心…',
    category: '临证精讲',
    doctor: '李显筑',
    views: '9340',
    duration: '15:08',
    image:
      'https://readdy.ai/api/search-image?query=Video%20thumbnail%20about%20qi%20and%20blood%20deficiency%20in%20traditional%20Chinese%20medicine%2C%20a%20bowl%20of%20nourishing%20herbal%20decoction%20with%20red%20dates%20and%20longan%20on%20a%20light%20table%2C%20warm%20soft%20light%2C%20elegant%20wellness%20still%2C%20high%20detail&width=640&height=360&seq=video-yy-08&orientation=landscape',
  },
  {
    id: 9,
    title: '#黄涛：以针为桥 以心为灯 致敬针灸路上的坚…',
    category: '针道传承',
    doctor: '黄涛',
    views: '7680',
    duration: '11:36',
    image:
      'https://readdy.ai/api/search-image?query=Video%20thumbnail%20paying%20tribute%20to%20acupuncture%20practitioners%2C%20fine%20acupuncture%20needles%20resting%20on%20a%20clean%20linen%20cloth%20beside%20a%20warm%20cup%20of%20tea%2C%20quiet%20warm%20studio%2C%20soft%20light%2C%20calm%20documentary%20still%2C%20high%20detail&width=640&height=360&seq=video-yy-09&orientation=landscape',
  },
  {
    id: 10,
    title: '赵勇教授：中医药厚积薄发，攻克"静默杀手"',
    category: '名家访谈',
    doctor: '赵勇',
    views: '1.3万',
    duration: '24:12',
    image:
      'https://readdy.ai/api/search-image?query=Video%20thumbnail%20about%20tackling%20a%20silent%20disease%20with%20Chinese%20medicine%2C%20a%20doctor%20holding%20a%20stethoscope%20beside%20a%20health%20screening%20chart%20and%20dried%20herbs%2C%20clean%20warm%20clinic%2C%20soft%20light%2C%20professional%20medical%20still%2C%20high%20detail&width=640&height=360&seq=video-yy-10&orientation=landscape',
  },
];

export const doctors = [
  {
    id: 1,
    name: '李显筑',
    title: '主任医师 · 全国名老中医 · 国务院政府特殊津贴专家 · 内分泌主委',
    hospital: '黑龙江省中医药科学院',
    tags: ['内分泌', '糖尿病'],
    intro: '国家药审中心中药新药审评专家、古代经典名方中药复方制剂专家审评委员会(第一批)委员、第六第七届中国中西医结合学会副会长、中国中西医结合学会内分泌专业委员会主任委员、世界中医药学会联合会代谢病专业委员会副会长、世界中医药学会联合会医养结合专业委员会常务副会长、中国中西医结合学会养生专业委员会副主任委员',
    avatar:
      'https://readdy.ai/api/search-image?query=Distinguished%20senior%20Chinese%20male%20endocrinology%20professor%20in%20his%20sixties%2C%20full%20silver%20grey%20hair%20neatly%20combed%2C%20gold-rimmed%20glasses%2C%20warm%20confident%20smile%2C%20crisp%20white%20medical%20coat%20over%20a%20deep%20red%20tie%2C%20clean%20soft%20warm%20ivory%20studio%20backdrop%2C%20three-quarter%20head%20and%20shoulders%2C%20professional%20medical%20editorial%20headshot%2C%20soft%20window%20light%2C%20high%20detail&width=400&height=400&seq=doctor-team-01&orientation=squarish',
  },
  {
    id: 2,
    name: '胡晓峰',
    title: '主任医师 · 国务院政府特殊津贴专家 · 博士研究生导师 · 肿瘤食疗',
    hospital: '中国中医科学院广安门医院',
    tags: ['脾胃病', '肿瘤食疗'],
    intro: '擅长治疗眩晕、头痛、失眠、抑郁、焦虑、慢性胃炎、胃溃疡、慢性腹泻、便秘、糖尿病、高血压，以及更年期综合征、月经失调等。从事中医临床及医史文献研究近40年，独撰《恶性肿瘤病中医食疗验方》《药草美容护肤验方》等著作，主编《中医外科伤科名著集成》《当代名老中医图集》等著作，整理出版中医古籍30余部，发表学术论文40余篇。临床师从国医大师余瀛鳌先生，辨证论治内科疑难杂病。',
    avatar:
      'https://readdy.ai/api/search-image?query=Senior%20Chinese%20male%20internal%20medicine%20scholar%20in%20his%20sixties%2C%20short%20grey%20hair%2C%20calm%20wise%20expression%2C%20white%20medical%20coat%20over%20a%20light%20blue%20shirt%2C%20clean%20warm%20neutral%20studio%20backdrop%2C%20professional%20medical%20editorial%20headshot%2C%20soft%20even%20light%2C%20high%20detail&width=400&height=400&seq=doctor-team-02&orientation=squarish',
  },
  {
    id: 3,
    name: '黄涛',
    title: '主任医师 · 院士传承 · 国际针灸 · 多次获奖',
    hospital: '中国中医科学院针灸医院',
    tags: ['针灸', '慢病调理'],
    intro: '女，医学博士，中国中医科学院针灸医院主任医师，美国哈佛大学医学院博士后，奥地利格拉兹医科大学访问学者，国家级非物质文化遗产中医针灸及程氏针灸（国医大师程莘农院士）学术继承人，第一届中国中医药杂志传真学者，中国老年保健学会生命科学分会副会长。现任东城区政协委员，九三学社北京市委委员、东城区副主委，中国中医科学院委员会主任委员。主持或参与过国家自然科学基金、科技部支撑计划、重点基础性项目等科学研究，在国内外刊物发表论文100余篇，论著5部。获得过中华中医药学会政策研究奖、著作一等奖，中国中医科学院科技进步奖、上海图书节图书一等奖等多种奖项。临床上擅长针药结合管理糖尿病、高血压等慢性疾病和干眼症、糖尿病视网膜病变、黄斑变性、肿瘤等疑难病症，对鼻炎、过敏性哮喘、痛经、子宫肌腺症肿瘤及术后康复、运动损伤等有较好疗效。',
    avatar:
      'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20acupuncture%20doctor%20in%20her%20fifties%2C%20shoulder%20length%20dark%20hair%2C%20warm%20composed%20smile%2C%20white%20medical%20coat%20over%20a%20jade%20green%20blouse%2C%20clean%20pale%20studio%20backdrop%2C%20professional%20medical%20editorial%20headshot%2C%20soft%20diffused%20light%2C%20high%20detail&width=400&height=400&seq=doctor-team-03&orientation=squarish',
  },
  {
    id: 4,
    name: '沈潜',
    title: '主任医师 · 博士研究生导师 · 全国优才 · 推拿理疗物理疗法',
    hospital: '北京中医药大学国医堂',
    tags: ['推拿理疗', '骨关节'],
    intro: '沈潜，中医内科博士，针灸推拿硕士，主任医师，教授，博士研究生导师，全国中医优秀临床人才，北京中医药大学国医堂中医门诊部主任，兼任国家中医药战略研究院教授，中华中医药学会青年委员会常委、补肾活血法分会副主任委员、小儿推拿外治分会青年副主委，中国中医药信息学会治未病分会副理事长，北京中医药学会科普专委会主委、青年工作委员会副主委、小儿推拿专委会副主委，北京中西医结合学会适宜技术专委会副主委、西学中工作委员会副主委，北京中医协会中医药技术技能人才工作委员会副主委，北京市朝阳区沈潜基层名医工作室指导老师。临床擅长针灸、推拿等非药物疗法治疗颈椎病、肩周炎、腰痛症、膝关节退行性病变等骨关节疾病，及失眠、肠易激综合征、痛经、多囊卵巢综合征、卵巢早衰、小儿近视、小儿生长发育障碍等内、妇、儿科病症。',
    avatar:
      'https://readdy.ai/api/search-image?query=Chinese%20male%20traditional%20medicine%20professor%20in%20his%20fifties%2C%20short%20neat%20black%20hair%2C%20friendly%20confident%20smile%2C%20white%20medical%20coat%20over%20a%20soft%20blue%20shirt%2C%20clean%20light%20neutral%20studio%20backdrop%2C%20professional%20medical%20editorial%20headshot%2C%20soft%20studio%20light%2C%20high%20detail&width=400&height=400&seq=doctor-team-04&orientation=squarish',
  },
];

export const partners = [
  {
    id: 1,
    name: '世界中医药学会联合会医疗机构管理专业委员会',
    short: '世界中联',
    logo: 'https://static.readdy.ai/image/40df70cb7fb470e01d31fe19c944f5a5/ca84ae8cc43b6e75656e8a28a169d985.png',
  },
  {
    id: 2,
    name: '中国中医药报',
    short: '中国中医药报',
    logo: 'https://static.readdy.ai/image/40df70cb7fb470e01d31fe19c944f5a5/6d67a2f3e1c42a8d94b655ec8a8a880f.png',
  },
  {
    id: 3,
    name: '中国诚通集团 · 诚通企业管理',
    short: '诚通集团',
    logo: 'https://static.readdy.ai/image/40df70cb7fb470e01d31fe19c944f5a5/087859d28428e0df5715c8dc28dc153b.png',
  },
  {
    id: 4,
    name: '北京易华录信息技术股份有限公司',
    short: '易华录',
    logo: 'https://static.readdy.ai/image/40df70cb7fb470e01d31fe19c944f5a5/e9b71efa2da7d94aa55cb7ab491856be.png',
  },
  {
    id: 5,
    name: '医汇云萃 · 中醫大數據云平台',
    short: '医汇云萃',
    logo: 'https://static.readdy.ai/image/40df70cb7fb470e01d31fe19c944f5a5/f9b9a42461de4f91e9787116d8157ca0.png',
  },
  {
    id: 6,
    name: '元合时空（北京）智能生物科技中心',
    short: '元合时空',
    logo: 'https://static.readdy.ai/image/40df70cb7fb470e01d31fe19c944f5a5/110045dc66439c26e9adbba3d6ac1302.png',
  },
];

export const hospitalCourses = [
  {
    id: 101,
    title: '中西医结合心血管疾病诊疗规范',
    category: '心血管病',
    doctor: '沈潜',
    lessons: 16,
    price: 399,
    image:
      'https://readdy.ai/api/search-image?query=Cardiovascular%20diagnosis%20course%20cover%2C%20a%20stethoscope%20and%20a%20blood%20pressure%20monitor%20beside%20dried%20Chinese%20herbs%20on%20a%20clean%20light%20beige%20surface%2C%20soft%20diffused%20studio%20lighting%2C%20minimal%20editorial%20style%2C%20warm%20neutral%20background%2C%20high%20detail&width=680&height=424&seq=course-hosp-01&orientation=landscape',
  },
  {
    id: 102,
    title: '中医内科疑难病辨治精讲',
    category: '脾胃病',
    doctor: '李显筑',
    lessons: 22,
    price: 459,
    image:
      'https://readdy.ai/api/search-image?query=Internal%20medicine%20differential%20diagnosis%20course%20cover%2C%20an%20open%20ancient%20Chinese%20medical%20text%20with%20a%20magnifying%20glass%20and%20herbal%20sprigs%2C%20clean%20ivory%20background%2C%20soft%20elegant%20studio%20light%2C%20minimal%20editorial%20photography%2C%20high%20detail&width=680&height=424&seq=course-hosp-02&orientation=landscape',
  },
  {
    id: 103,
    title: '中医肿瘤康复临床路径实践',
    category: '肿瘤康复',
    doctor: '胡晓峰',
    lessons: 14,
    price: 429,
    image:
      'https://readdy.ai/api/search-image?query=Oncology%20rehabilitation%20course%20cover%2C%20a%20bowl%20of%20nourishing%20herbal%20soup%20with%20goji%20berries%20and%20a%20small%20ceramic%20spoon%2C%20warm%20cream%20background%2C%20soft%20natural%20light%2C%20minimal%20editorial%20photography%2C%20high%20detail&width=680&height=424&seq=course-hosp-03&orientation=landscape',
  },
  {
    id: 104,
    title: '针灸治疗颈肩腰腿痛实操',
    category: '针灸推拿',
    doctor: '黄涛',
    lessons: 20,
    price: 379,
    image:
      'https://readdy.ai/api/search-image?query=Acupuncture%20pain%20treatment%20course%20cover%2C%20fine%20acupuncture%20needles%20resting%20on%20a%20clean%20linen%20cloth%20beside%20a%20small%20ceramic%20dish%2C%20smooth%20ivory%20background%2C%20soft%20studio%20light%2C%20minimal%20traditional%20medicine%20editorial%20photography%2C%20high%20detail&width=680&height=424&seq=course-hosp-04&orientation=landscape',
  },
  {
    id: 105,
    title: '中西医结合妇科常见病诊疗',
    category: '妇科',
    doctor: '黄涛',
    lessons: 18,
    price: 419,
    image:
      'https://readdy.ai/api/search-image?query=Gynecology%20Chinese%20medicine%20course%20cover%2C%20dried%20rose%20buds%20and%20red%20dates%20beside%20a%20white%20ceramic%20cup%20on%20a%20clean%20cream%20surface%2C%20soft%20natural%20light%2C%20minimal%20editorial%20photography%2C%20high%20detail&width=680&height=424&seq=course-hosp-05&orientation=landscape',
  },
  {
    id: 106,
    title: '中医骨伤手法整复与康复',
    category: '筋骨病',
    doctor: '沈潜',
    lessons: 15,
    price: 389,
    image:
      'https://readdy.ai/api/search-image?query=Orthopedics%20and%20traumatology%20course%20cover%2C%20a%20wooden%20massage%20tool%20and%20a%20rolled%20elastic%20bandage%20on%20a%20clean%20light%20grey%20surface%2C%20soft%20studio%20light%2C%20minimal%20medical%20editorial%20photography%2C%20high%20detail&width=680&height=424&seq=course-hosp-06&orientation=landscape',
  },
  {
    id: 107,
    title: '中西医结合脑病诊疗进展',
    category: '脑病',
    doctor: '李显筑',
    lessons: 12,
    price: 359,
    image:
      'https://readdy.ai/api/search-image?query=Neurology%20Chinese%20medicine%20course%20cover%2C%20a%20stethoscope%20beside%20a%20small%20bowl%20of%20walnuts%20and%20a%20cup%20of%20herbal%20tea%20on%20a%20light%20beige%20surface%2C%20soft%20diffused%20light%2C%20minimal%20editorial%20photography%2C%20high%20detail&width=680&height=424&seq=course-hosp-07&orientation=landscape',
  },
  {
    id: 108,
    title: '中西医结合内分泌代谢病管理',
    category: '内分泌',
    doctor: '胡晓峰',
    lessons: 17,
    price: 409,
    image:
      'https://readdy.ai/api/search-image?query=Endocrinology%20and%20metabolism%20course%20cover%2C%20fresh%20vegetables%2C%20whole%20grains%20and%20a%20small%20glucometer%20arranged%20on%20a%20clean%20light%20surface%2C%20soft%20natural%20light%2C%20minimal%20healthy%20diet%20editorial%20photography%2C%20high%20detail&width=680&height=424&seq=course-hosp-08&orientation=landscape',
  },
];

export const hospitals = [
  {
    id: 1,
    name: '中国中医科学院西苑医院山西医院',
    image:
      'https://readdy.ai/api/search-image?query=Towering%20modern%20white%20and%20glass%20integrated%20Chinese%20and%20Western%20medicine%20hospital%20with%20crisp%20geometric%20facade%20and%20vertical%20planted%20green%20strips%2C%20wide%20landscaped%20entrance%20plaza%20with%20fountain%20and%20flag%20poles%2C%20clear%20northern%20China%20blue%20sky%2C%20crisp%20midday%20daylight%2C%20professional%20architectural%20photography%2C%20high%20detail%2C%20cool%20clean%20tones&width=860&height=560&seq=hospital-tcm-01&orientation=landscape&nocache=true',
    campusGallery: [
      {
        label: '门诊大厅',
        image:
          'https://readdy.ai/api/search-image?query=Bright%20modern%20outpatient%20service%20hall%20of%20an%20integrated%20Chinese%20and%20Western%20medicine%20hospital%2C%20tall%20ceiling%20with%20warm%20wood%20louvers%20and%20clean%20white%20stone%20walls%2C%20orderly%20service%20counters%20and%20queuing%20patients%2C%20glass%20curtain%20wall%20admitting%20clear%20northern%20daylight%2C%20professional%20healthcare%20interior%20photography%2C%20high%20detail&width=600&height=460&seq=hospital-hall-01&orientation=landscape',
      },
      {
        label: '住院病区',
        image:
          'https://readdy.ai/api/search-image?query=Calm%20inpatient%20ward%20corridor%20in%20a%20modern%20Chinese%20hospital%2C%20soft%20warm%20lighting%20along%20white%20walls%20with%20subtle%20wood%20accents%2C%20neatly%20arranged%20patient%20room%20doors%20and%20a%20tidy%20nursing%20station%2C%20green%20plants%20at%20the%20far%20end%2C%20hygienic%20and%20reassuring%20atmosphere%2C%20professional%20interior%20photography%2C%20high%20detail&width=600&height=460&seq=hospital-ward-01&orientation=landscape',
      },
      {
        label: '康养花园',
        image:
          'https://readdy.ai/api/search-image?query=Landscaped%20hospital%20healing%20garden%20with%20a%20curved%20stone%20walkway%2C%20low%20green%20shrubs%20and%20wooden%20benches%2C%20patients%20strolling%20in%20soft%20daylight%2C%20glass%20hospital%20wing%20softly%20blurred%20behind%2C%20northern%20China%20clear%20sky%2C%20warm%20inviting%20editorial%20photography%2C%20high%20detail&width=600&height=460&seq=hospital-garden-01&orientation=landscape',
      },
    ],
    intro:
      '始建于1983年，1988年开诊，2021年6月成为全国首批中医类别国家区域医疗中心建设单位，由中国中医科学院西苑医院合作共建。心血管病中心是首批国家区域医疗中心三大建设中心之一，由中国中医科学院院士陈可冀教授担任顾问；脾胃病科为国家中医药管理局重点专科和华北区域中医专科诊疗中心核心单位，肛肠科连续四批次入选国家中医药管理局重点专科并入选国家优势专科建设学科。医院是国家区域医疗中心——全国首家中医类国家区域医疗中心建设依托单位，编制床位1600张，临床科室40个；国家级重点学科2个、国家中医药管理局重点专科4个、国家级中医优势专科6个；在职职工1170人（副高及以上286人）。',
    advantageDiseases: [
      {
        name: '胃痞（慢性胃炎、消化性溃疡）中西医结合诊疗方案',
        desc: '推广单位胃痞患者规范诊疗方案应用率达60%以上，患者胃痛发作频次减少30%，胃脘痛病变（如萎缩、肠化）逆转率或稳定率提升25%，再入院率下降20%。',
        diseaseId: 7,
      },
      {
        name: '痞满（功能性消化不良）中医特色诊疗方案',
        desc: '推广单位痞满患者中医方案规范应用率达60%以上，患者消化不良症状评分显著改善，年急性加重次数平均减少30%，生活质量评分显著提升。',
        diseaseId: 8,
      },
      {
        name: '胃痞（胆囊炎、脂肪肝）早期代谢病逆转综合诊疗方案',
        desc: '推广单位胃痞患者规范诊疗方案应用率达60%以上，患者脂肪肝逆转率或肝功能异常改善率提升25%，胆囊炎发作频次减少30%，相关代谢指标（如血脂、血糖）改善率显著提升。',
        diseaseId: 9,
      },
    ],
    preparations: [
      {
        name: '小儿芦参抗感颗粒',
        desc: '益气固表，健脾补肺，升阳散邪，调和营卫，消食导滞。用于面色萎靡、头发枯黄、鼻根发青、形体消瘦、纳差、易腹泻、呕吐等症；反复感冒见上述证候者。',
      },
      {
        name: '消痔化滞洗剂',
        desc: '清热燥湿，活血化瘀，祛腐止痒。用于痔、肛裂、肛痈、肛瘘、肛门瘙痒及肛门病术后外用。',
      },
      {
        name: '胃康降逆颗粒',
        desc: '健脾化湿和胃，宽中降气，平调寒热。用于肝脾胃不和、寒湿热错杂所致的脘闷肠鸣、腹痛下利、反酸烧心、胃脘痞满；急性胃肠炎、胃食管反流病见上述证候者。',
      },
    ],
    website: 'https://www.sxzyfy.com',
    doctors: [
      { name: '李显筑', title: '主任医师 · 全国名老中医' },
      { name: '胡晓峰', title: '主任医师 · 博士研究生导师' },
    ],
  },
  {
    id: 2,
    name: '榆林市中医医院',
    image:
      'https://readdy.ai/api/search-image?query=Low-rise%20regional%20traditional%20Chinese%20medicine%20hospital%20campus%20in%20northern%20Shaanxi%2C%20grey%20brick%20walls%20paired%20with%20a%20modern%20glass%20wing%20and%20traditional%20sloping%20dark%20tiled%20eaves%2C%20small%20courtyard%20with%20old%20pine%20trees%20and%20stone%20benches%2C%20warm%20golden%20late%20afternoon%20light%2C%20loess%20plateau%20hills%20faint%20in%20background%2C%20architectural%20photography%2C%20high%20detail&width=860&height=560&seq=hospital-tcm-02&orientation=landscape&nocache=true',
    campusGallery: [
      {
        label: '门诊大厅',
        image:
          'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20medicine%20outpatient%20hall%20with%20grey%20brick%20walls%20and%20wooden%20lattice%20screens%2C%20warm%20tile%20floor%2C%20neatly%20arranged%20service%20windows%20and%20waiting%20benches%2C%20a%20subtle%20herbal%20medicine%20display%20cabinet%2C%20soft%20golden%20afternoon%20light%2C%20calm%20regional%20hospital%20interior%20photography%2C%20high%20detail&width=600&height=460&seq=hospital-hall-02&orientation=landscape',
      },
      {
        label: '住院病区',
        image:
          'https://readdy.ai/api/search-image?query=Serene%20inpatient%20ward%20of%20a%20northern%20Shaanxi%20Chinese%20medicine%20hospital%2C%20grey%20brick%20and%20warm%20wood%20interior%2C%20tidy%20patient%20beds%20with%20soft%20quilts%2C%20wooden%20lattice%20window%20letting%20in%20gentle%20light%2C%20a%20small%20green%20plant%20on%20the%20sill%2C%20quiet%20comforting%20atmosphere%2C%20interior%20photography%2C%20high%20detail&width=600&height=460&seq=hospital-ward-02&orientation=landscape',
      },
      {
        label: '康养花园',
        image:
          'https://readdy.ai/api/search-image?query=Quiet%20Chinese%20medicine%20courtyard%20healing%20garden%20with%20grey%20brick%20walls%2C%20ancient%20pine%20trees%20and%20a%20stone-paved%20path%2C%20wooden%20benches%20and%20a%20small%20fish%20pond%2C%20soft%20golden%20afternoon%20light%2C%20serene%20northern%20Shaanxi%20atmosphere%2C%20editorial%20photography%2C%20high%20detail&width=600&height=460&seq=hospital-garden-02&orientation=landscape',
      },
    ],
    intro:
      '位于陕西榆林，是一所三级甲等中医医院，也是陕北区域中医中心。医院是陕西中医药大学附属榆林医院，以骨伤、骨病、针灸、老年病为特色，是陕北中医药传承基地，同时是全国三级甲等中医院、国家住院医师规范化培训基地、国家中医药适宜技术研究推广中心建设单位。医院实行“一院两区”布局，设有六大医院、五大中心；开放床位1100张，科室52个；职工1430人（副高及以上327人）。',
    advantageDiseases: [],
    preparations: [
      {
        name: '参芪补血颗粒',
        desc: '益气养阴，补血安神。用于气阴两虚、血虚所致的免疫力低下、久病咳喘、失眠、汗证、贫血、病后虚弱等。症见：气短、精神不振、体倦乏力、面色苍白、心悸、心烦、失眠、头昏、记忆力减退、四肢冰凉、舌淡、脉虚等。',
      },
      {
        name: '清热退黄颗粒',
        desc: '清热凉血，利湿退黄，化瘀通络。用于湿热浸淫、困阻中焦、胆汁不循常道而致的黄疸。症见：身目发黄、黄色不甚鲜明、头重身困、胸脘痞满、食欲减退、恶心呕吐、腹胀或大便溏垢、小便不利、舌苔厚腻微黄、脉象濡数等。',
      },
      {
        name: '葛根通络颗粒',
        desc: '祛风化痰，通络止痛。用于肝风痰湿型偏头痛。',
      },
    ],
    website: 'https://www.ylzyy.com',
    doctors: [
      { name: '沈潜', title: '主任医师 · 博士研究生导师' },
      { name: '黄涛', title: '主任医师 · 院士传承' },
    ],
  },
  {
    id: 3,
    name: '上海中医药大学附属岳阳中西医结合医院',
    image:
      'https://readdy.ai/api/search-image?query=Metropolitan%20high-rise%20hospital%20tower%20in%20downtown%20Shanghai%2C%20curved%20blue-green%20glass%20curtain%20wall%20mirroring%20a%20dense%20city%20skyline%20of%20office%20towers%2C%20busy%20pedestrian%20street%20and%20metro%20entrance%20below%2C%20soft%20overcast%20daylight%2C%20urban%20architectural%20photography%2C%20high%20detail%2C%20cool%20modern%20tones&width=860&height=560&seq=hospital-tcm-03&orientation=landscape&nocache=true',
    campusGallery: [
      {
        label: '门诊大厅',
        image:
          'https://readdy.ai/api/search-image?query=Contemporary%20outpatient%20hall%20of%20a%20Shanghai%20urban%20hospital%2C%20polished%20stone%20floor%20reflecting%20a%20blue-green%20glass%20curtain%20wall%2C%20self-service%20kiosks%20and%20information%20counters%2C%20busy%20patients%20and%20staff%2C%20soft%20overcast%20daylight%2C%20metropolitan%20modern%20healthcare%20interior%20photography%2C%20cool%20clean%20tones%2C%20high%20detail&width=600&height=460&seq=hospital-hall-03&orientation=landscape',
      },
      {
        label: '住院病区',
        image:
          'https://readdy.ai/api/search-image?query=Modern%20inpatient%20ward%20of%20an%20urban%20Shanghai%20hospital%2C%20minimalist%20white%20and%20wood%20hospital%20beds%20with%20soft%20linens%2C%20large%20window%20overlooking%20a%20hazy%20city%20skyline%2C%20warm%20reading%20lamp%20and%20a%20green%20plant%2C%20calm%20hygienic%20atmosphere%2C%20contemporary%20interior%20photography%2C%20high%20detail&width=600&height=460&seq=hospital-ward-03&orientation=landscape',
      },
      {
        label: '康养花园',
        image:
          'https://readdy.ai/api/search-image?query=Elevated%20landscaped%20terrace%20garden%20of%20an%20urban%20hospital%2C%20geometric%20planters%20with%20green%20shrubs%20beside%20a%20glass%20curtain%20wall%2C%20guests%20resting%20on%20modern%20benches%2C%20Shanghai%20skyline%20softly%20out%20of%20focus%20behind%2C%20soft%20overcast%20daylight%2C%20modern%20architectural%20editorial%20photography%2C%20high%20detail&width=600&height=460&seq=hospital-garden-03&orientation=landscape',
      },
    ],
    intro:
      '创建于1952年，是全国首批三级甲等中西医结合医院、首批重点中西医结合医院示范单位、国家中医临床研究基地建设单位。总部地处虹口区，是上海市北部中心城区唯一一家三甲中医医疗机构，拥有国家中西医协同“旗舰”科室3个（心血管病科、消化病科、神经内科），国家中医优势专科（重症医学科），针灸、推拿为传统特色优势学科，设有上海市针灸经络研究所，荣获全国文明单位、上海市政府质量金奖等荣誉。医院是国家区域医疗中心输出医院、国家中西医协同“旗舰”医院试点、国家医学中心（中医类）创建单位；开放床位1150张，在职员工2000人（副高级及以上职称中西医结合医师424人）；年门诊量342万人次、出院9.3万人次、手术2万人次、总收入35亿元。',
    advantageDiseases: [
      {
        name: '肝硬化腹水“三治两防”综合方案',
        desc: '配合“水熨贴”外敷及针灸艾灸，实现西医解急症、中医固根本的协同疗效。',
        diseaseId: 10,
      },
      {
        name: '泌尿系统结石“个性化调理湿热体质＋调节尿液酸碱度＋抑制结石再生”中西医结合疗法',
        desc: '可使结石3年复发率明显下降。',
        diseaseId: 11,
      },
      {
        name: '胸外科“术前针刺麻醉降低麻醉风险＋术中精准微创＋术后中医药扶正减毒”全生命周期整合治疗',
        desc: '显著提升患者疗效和生活质量。',
        diseaseId: 12,
      },
    ],
    preparations: [
      {
        name: '痰热清注射液',
        desc: '能显著缓解咳嗽、气促等症状，改善炎症指标，在呼吸系统感染性疾病中具有明确的临床价值。临床实践证明，该制剂疗效确切、安全性良好，为入选品种的合理用药提供了有力支撑。',
      },
    ],
    website: 'https://www.shyueyanghospital.com',
    doctors: [
      { name: '胡晓峰', title: '主任医师 · 博士研究生导师' },
      { name: '黄涛', title: '主任医师 · 院士传承' },
    ],
  },
  {
    id: 4,
    name: '广东省中医院',
    image:
      'https://readdy.ai/api/search-image?query=Grand%20southern%20Chinese%20medicine%20hospital%20with%20a%20sweeping%20white%20curved%20roof%20and%20huge%20glass%20atrium%2C%20lush%20green%20tropical%20garden%20courtyard%20with%20a%20reflecting%20water%20feature%20and%20banyan%20trees%2C%20bright%20sunny%20Guangzhou%20day%2C%20professional%20architectural%20photography%2C%20high%20detail%2C%20vivid%20green%20and%20white%20tones&width=860&height=560&seq=hospital-tcm-04&orientation=landscape&nocache=true',
    campusGallery: [
      {
        label: '门诊大厅',
        image:
          'https://readdy.ai/api/search-image?query=Grand%20outpatient%20hall%20of%20a%20southern%20Chinese%20medicine%20hospital%20under%20a%20sweeping%20white%20curved%20ceiling%2C%20abundant%20glazing%20and%20a%20huge%20glass%20atrium%2C%20indoor%20tropical%20greenery%20and%20a%20reflecting%20water%20feature%2C%20bright%20sunny%20Guangzhou%20daylight%2C%20spacious%20modern%20healthcare%20interior%20photography%2C%20high%20detail&width=600&height=460&seq=hospital-hall-04&orientation=landscape',
      },
      {
        label: '住院病区',
        image:
          'https://readdy.ai/api/search-image?query=Bright%20inpatient%20ward%20of%20a%20southern%20Chinese%20hospital%2C%20airy%20white%20and%20warm%20wood%20interior%2C%20hospital%20beds%20with%20soft%20linens%2C%20floor%20to%20ceiling%20window%20looking%20onto%20green%20tropical%20plants%2C%20gentle%20warm%20light%2C%20comfortable%20hygienic%20atmosphere%2C%20interior%20photography%2C%20high%20detail&width=600&height=460&seq=hospital-ward-04&orientation=landscape',
      },
      {
        label: '康养花园',
        image:
          'https://readdy.ai/api/search-image?query=Lush%20tropical%20healing%20garden%20of%20a%20southern%20Chinese%20hospital%2C%20winding%20boardwalk%20over%20a%20lotus%20pond%2C%20huge%20banyan%20trees%20and%20exotic%20greenery%2C%20patients%20walking%20in%20the%20shade%2C%20bright%20sunny%20Guangzhou%2C%20vibrant%20green%20editorial%20photography%2C%20high%20detail&width=600&height=460&seq=hospital-garden-04&orientation=landscape',
      },
    ],
    intro:
      '创建于1926年，又称广州中医药大学第二附属医院、广东省中医药科学院。开放床位3219张，员工7710名，拥有院士1人、国医大师1人、全国名中医2人、岐黄学者6人。建有6个国家区域中医诊疗中心、6个国家卫生健康委重点专科、24个国家中医药管理局重点专科，年服务患者量连续20多年稳居全国中医医院首位，获批建设全国唯一的粤港澳联合国家中医医疗中心，连续10年蝉联全国中医医院竞争力排行榜榜首。医院拥有国家中医临床研究基地、国家中医药传承创新中心项目储备库；6个国家区域中医（专科）诊疗中心、23个国家级重点专科、33个省级重点专科、11个国家级重点学科；开放床位3219张，员工7763名（副高级及以上职称中西医结合医师1118人）；6个院区、4个门诊部。',
    advantageDiseases: [
      {
        name: '中西医结合治疗心力衰竭',
        desc: '患者症状改善率达80%-90%，再住院风险降低；益气温阳法治疗急性心肌梗死后主要不良心血管事件风险降低49%，左心室射血分数提高4.8%。',
        diseaseId: 13,
      },
      {
        name: '中风的慢病管理体系',
        desc: '卒中复发率2.88%-3.91%，显著低于全国水平。',
        diseaseId: 14,
      },
      {
        name: '中西医结合治疗类风湿关节炎',
        desc: '24周的ACR20/50/70达标率分别为72.1%、60.5%、30.2%，优于单用甲氨蝶呤（MTX）方案，与经典联合方案（雷公藤＋MTX）疗效相当，并展现出更优的安全性。',
        diseaseId: 4,
      },
    ],
    preparations: [
      {
        name: '复康宁胶囊',
        desc: '是治疗乳腺癌的专病专方，可提高化疗临床缓解率，改善病理MP分级，缓解化疗导致的系列症状，降低Ⅳ度骨髓抑制发生率，提高乳腺癌患者生存质量。',
      },
      {
        name: '三芪口服液',
        desc: '可以改善慢性肾衰竭患者的高凝状态，改善临床症状、调节免疫功能、减少尿蛋白、改善贫血，促进下肢静脉血栓的再通。相关研究项目荣获广东省科学技术奖三等奖。',
      },
      {
        name: '通腑醒神胶囊',
        desc: '以中风暴病“腑实证”为核心病机，通腑醒脑、豁痰开窍，整体抑菌，荡涤浊毒，药专效宏。',
      },
    ],
    website: 'https://www.gdhtcm.com',
    doctors: [
      { name: '沈潜', title: '主任医师 · 博士研究生导师' },
      { name: '黄涛', title: '主任医师 · 院士传承' },
      { name: '胡晓峰', title: '主任医师 · 博士研究生导师' },
    ],
  },
  {
    id: 5,
    name: '广东省中医院海南医院（海南省中医院）',
    image:
      'https://readdy.ai/api/search-image?query=Tropical%20island%20resort-style%20Chinese%20medicine%20hospital%2C%20low-rise%20white%20concrete%20building%20with%20wooden%20sunshade%20louvers%20and%20terraced%20balconies%2C%20surrounded%20by%20tall%20coconut%20palms%20and%20blooming%20frangipani%20flowers%2C%20bright%20turquoise%20sky%20and%20seaside%20breeze%2C%20warm%20sunny%20Hainan%20light%2C%20professional%20architectural%20photography%2C%20high%20detail&width=860&height=560&seq=hospital-tcm-05&orientation=landscape&nocache=true',
    campusGallery: [
      {
        label: '门诊大厅',
        image:
          'https://readdy.ai/api/search-image?query=Relaxing%20outpatient%20hall%20of%20a%20tropical%20island%20Chinese%20medicine%20hospital%2C%20low%20white%20columns%20and%20wooden%20louver%20screens%2C%20breezy%20open%20layout%20with%20potted%20palms%20and%20rattan%20waiting%20chairs%2C%20bright%20turquoise%20daylight%20streaming%20in%2C%20warm%20sunny%20Hainan%20island%20healthcare%20interior%20photography%2C%20high%20detail&width=600&height=460&seq=hospital-hall-05&orientation=landscape',
      },
      {
        label: '住院病区',
        image:
          'https://readdy.ai/api/search-image?query=Airy%20inpatient%20ward%20of%20a%20tropical%20island%20hospital%2C%20white%20walls%20with%20wooden%20sunshade%20details%2C%20hospital%20beds%20with%20crisp%20linens%20beside%20a%20window%20overlooking%20coconut%20palms%2C%20gentle%20sea%20breeze%20and%20warm%20sunlight%2C%20calm%20restful%20atmosphere%2C%20interior%20photography%2C%20high%20detail&width=600&height=460&seq=hospital-ward-05&orientation=landscape',
      },
      {
        label: '康养花园',
        image:
          'https://readdy.ai/api/search-image?query=Tropical%20seaside%20hospital%20garden%20with%20coconut%20palms%20and%20frangipani%2C%20a%20wooden%20walkway%20between%20white%20low-rise%20buildings%2C%20sun%20loungers%20under%20shade%2C%20turquoise%20sky%20and%20ocean%20breeze%2C%20warm%20sunny%20Hainan%20light%2C%20relaxing%20editorial%20photography%2C%20high%20detail&width=600&height=460&seq=hospital-garden-05&orientation=landscape',
      },
    ],
    intro:
      '创建于1954年，是海南省唯一一家省级三级甲等中医医院。2021年获批国家区域医疗中心，由广东省中医院输出共建，是海南省中医药学会、海南省中医医联体、海南省中医医疗集团的牵头单位，承担“大病不出岛”的自贸港中医医疗高地建设任务。医院是国家医学中心创建单位、国家中医临床研究基地、国家中医药传承创新中心项目储备库；拥有1个国家区域中医（专科）诊疗中心、25个国家级重点专科、55个省级重点专科、11个国家级重点学科；开放床位3219张，员工7683名（副高级及以上职称中西医结合医师1118人）；6个院区、4个门诊部。',
    advantageDiseases: [
      {
        name: '中枢性眩晕中西医协同诊疗方案',
        desc: '依托王新陆国医大师脑病“脑神失调、浊毒损脑”学术思想，中药平肝熄风化痰，配合针灸、前庭康复训练，改善眩晕症状，降低复发风险。',
        diseaseId: 15,
      },
      {
        name: '腰椎间盘突出中西医协同诊疗方案',
        desc: '运用林定坤教授“筋骨平衡”学术思想，采用五阶梯治疗模式，针灸推拿、中药内服外用联合微创/手术，缓解腰腿疼痛，恢复筋骨平衡，改善肢体功能。',
        diseaseId: 16,
      },
      {
        name: '脑梗死中西医协同诊疗方案',
        desc: '急性期脑脉开合等中医特色技术配合西医溶栓、抗凝、抗血小板、早期中药、针灸、康复训练，减轻神经功能缺损，降低致残率。',
        diseaseId: 17,
      },
    ],
    preparations: [
      {
        name: '补气益脑胶囊',
        desc: '补气、调心脉、益脑髓；用于冠心病、心绞痛、中风、半身不遂、口舌歪斜、言语不利、偏身麻木、头昏头晕目眩、纳呆胸闷、便秘或腹痛，及高血脂症、高粘血症、脑动脉硬化症等。年销量超6万瓶，是老年病防治明星制剂，心脑血管疾病防治代表性制剂。',
      },
      {
        name: '大螈蜈蚣通络胶囊',
        desc: '养阴、清热、利咽；用于咽喉肿痛、声音嘶哑、急慢性咽炎。年销量1.5万盒，被誉为“利咽宝”制剂，是外感热病中医治疗特色制剂。',
      },
      {
        name: '补血安神丸',
        desc: '补肾益脑、补肝益血、活血安神；用于更年期综合征。年销量超4万瓶，注重养血凉血、除烦安神，是突出病种辨证特色、临床疗效确切、深受患者欢迎的院内制剂。',
      },
    ],
    website: 'https://www.gdszyyhnxy.cn',
    doctors: [
      { name: '黄涛', title: '主任医师 · 院士传承' },
      { name: '李显筑', title: '主任医师 · 全国名老中医' },
    ],
  },
  {
    id: 6,
    name: '武汉中西医结合骨科医院（武汉体育学院附属医院）',
    image:
      'https://readdy.ai/api/search-image?query=Modern%20three-tier%20bone%20and%20joint%20specialty%20hospital%20building%20in%20Wuhan%2C%20white%20and%20warm%20grey%20facade%20with%20a%20glass%20curtain%20wall%20and%20vertical%20greenery%2C%20wide%20entrance%20plaza%20with%20trees%20and%20flag%20poles%20under%20a%20clear%20bright%20sky%2C%20professional%20architectural%20photography%2C%20high%20detail%2C%20clean%20warm-neutral%20tones&width=860&height=560&seq=hospital-tcm-06&orientation=landscape',
    campusGallery: [
      {
        label: '门诊大厅',
        image:
          'https://readdy.ai/api/search-image?query=Bright%20modern%20outpatient%20service%20hall%20of%20a%20bone%20and%20joint%20specialty%20hospital%2C%20clean%20white%20walls%20with%20warm%20wood%20accents%20and%20orderly%20service%20counters%2C%20glass%20curtain%20wall%20admitting%20soft%20daylight%2C%20a%20few%20patients%20and%20staff%2C%20professional%20healthcare%20interior%20photography%2C%20high%20detail&width=600&height=460&seq=hospital-hall-06&orientation=landscape',
      },
      {
        label: '住院病区',
        image:
          'https://readdy.ai/api/search-image?query=Calm%20inpatient%20ward%20corridor%20of%20a%20modern%20orthopedic%20hospital%2C%20warm%20lighting%20along%20white%20walls%20with%20soft%20wood%20details%2C%20tidy%20nursing%20station%20and%20patient%20room%20doors%2C%20a%20green%20plant%20at%20the%20far%20end%2C%20hygienic%20reassuring%20atmosphere%2C%20professional%20interior%20photography%2C%20high%20detail&width=600&height=460&seq=hospital-ward-06&orientation=landscape',
      },
      {
        label: '康养花园',
        image:
          'https://readdy.ai/api/search-image?query=Landscaped%20rehabilitation%20garden%20of%20an%20orthopedic%20hospital%2C%20curved%20stone%20walkway%20with%20low%20green%20shrubs%20and%20wooden%20benches%2C%20patients%20walking%20slowly%20in%20soft%20daylight%2C%20modern%20hospital%20wing%20softly%20blurred%20behind%2C%20warm%20inviting%20editorial%20photography%2C%20high%20detail&width=600&height=460&seq=hospital-garden-06&orientation=landscape',
      },
    ],
    intro:
      '始建于1975年，经中国人民解放军第七研究院批准建设“第七研究院武汉医院”，后更名为中国舰船研究院武汉672医院，隶属中国船舶集团公司第七研究院。1997年更名为武汉市第二中西医结合医院，2014年更名为“武汉六七二中西医结合医院”，2018年升级为三级专科医院，更名为“湖北六七二中西医结合骨科医院”，2021年成功创建三级甲等骨科专科医院。2022年顺应国有企业办医疗机构深化改革要求，经湖北省批准成为武汉体育学院直属附属医院。医院年门诊量30万人次，住院患者1.5万人次，手术台次5000台；拥有12个临床专业学科、11个临床辅助科室。骨科是医院特色优势学科，现有8个病区、9个二级亚专业，骨伤、骨病为国家中医药管理局中医协同“1级”科室建设单位；骨伤科、针灸康复科、老年病科为湖北省重点专科。',
    advantageDiseases: [
      {
        name: '腰椎间盘突出（腰椎间盘突出症）诊疗方案',
        desc: '累计诊疗11.5085万例，其中保守治疗占比约70%、微创手术占比约20%；临床有效率超过95%，术后复发率低于5%，患者满意度98%。',
        diseaseId: 16,
      },
      {
        name: '腰椎椎管狭窄（腰椎椎管狭窄症）诊疗方案',
        desc: '累计诊疗2.0411万例，术后随访优良率92%，腰腿痛及间歇性跛行症状显著改善；其中保守治疗有效缓解症状者占65%，手术患者术后功能恢复优良率90%。',
        diseaseId: 18,
      },
      {
        name: '膝关节病（膝痹）诊治方案',
        desc: '采用中药内服外用、针灸、针刀与关节功能锻炼相结合的综合方案，配合阶梯化治疗，帮助缓解疼痛、改善关节功能、延缓病情进展。',
        diseaseId: 19,
      },
    ],
    preparations: [
      {
        name: '壮腰健肾丸',
        desc: '年度使用人次9000余人，其中间访患者2700余人，显效患者2500余人，有效率达90.2%。该制剂疗效确切，症状改善显著，安全性良好，稳定性良好，值得临床大力推广。',
      },
      {
        name: '关节黑颗粒',
        desc: '年度使用人次2600余人，其中间访患者1100余人，显效患者1000余人，有效率达93%。该制剂疗效确切，症状改善显著，稳定性良好。',
      },
      {
        name: '强力五虎颗粒',
        desc: '年度使用人次10000余人，其中间访患者4000余人，显效患者3800余人，有效率达95%。该制剂疗效确切，临床获益显著，安全性良好，稳定性好，值得信任。',
      },
    ],
    website: 'https://www.hbgkyy.com',
    doctors: [
      { name: '沈潜', title: '主任医师 · 博士研究生导师' },
      { name: '黄涛', title: '主任医师 · 院士传承' },
    ],
  },
];

export const diseases = [
  {
    id: 1,
    name: '颈椎病',
    image:
      'https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20middle%20aged%20office%20worker%20gently%20massaging%20a%20stiff%20neck%2C%20clean%20warm%20neutral%20background%2C%20soft%20studio%20light%2C%20health%20care%20concept%20photography%2C%20calm%20mood%2C%20high%20detail&width=640&height=460&seq=disease-01&orientation=landscape',
    symptom: '颈肩酸痛僵硬、上肢麻木、头晕头痛，久坐或低头后加重，严重时影响睡眠与日常活动。',
    detail: [
      '颈椎病多因长期伏案、姿势不良导致颈部经络气血运行不畅，中医辨证常见风寒湿痹、气滞血瘀与肝肾不足等证型。',
      '平台联合三甲医院整理优势病种诊疗方案，采用针灸、推拿、牵引、中药内服外敷相结合的综合调理路径，并按疗程进行效果随访。',
    ],
  },
  {
    id: 2,
    name: '失眠',
    image:
      'https://readdy.ai/api/search-image?query=Serene%20bedroom%20with%20soft%20evening%20lamp%20glow%20and%20a%20cup%20of%20herbal%20tea%20on%20the%20nightstand%2C%20warm%20minimal%20interior%2C%20calm%20restful%20atmosphere%2C%20editorial%20photography%2C%20soft%20light&width=640&height=460&seq=disease-02&orientation=landscape',
    symptom: '入睡困难、易醒多梦、醒后疲乏，常伴心烦、健忘、头晕乏力等，影响日间精力与情绪。',
    detail: [
      '中医认为失眠多与心脾两虚、肝郁化火、阴虚火旺相关，强调辨证施治、标本兼顾，兼顾情绪与作息调理。',
      '平台提供中药调理、针灸安神、耳穴压豆与睡眠行为指导相结合的全周期方案，帮助逐步重建正常睡眠节律。',
    ],
  },
  {
    id: 3,
    name: '慢性胃炎',
    image:
      'https://readdy.ai/api/search-image?query=Warm%20bowl%20of%20nourishing%20herbal%20congee%20with%20goji%20berries%20on%20a%20light%20wooden%20table%2C%20clean%20beige%20background%2C%20soft%20natural%20light%2C%20food%20and%20health%20editorial%20photography%2C%20high%20detail&width=640&height=460&seq=disease-03&orientation=landscape',
    symptom: '上腹隐痛胀满、餐后加重、食欲不振、反酸嗳气，病程迁延反复，与饮食情绪密切相关。',
    detail: [
      '慢性胃炎属中医“胃脘痛”范畴，多因饮食不节、情志失调、脾胃虚弱所致，治疗重在健脾和胃、疏肝理气。',
      '平台整合中西医结合诊疗规范，配合中药汤剂、穴位贴敷与个性化饮食管理，形成可长期坚持的养护方案。',
    ],
  },
  {
    id: 4,
    name: '类风湿关节炎',
    image:
      'https://readdy.ai/api/search-image?query=Gentle%20hands%20holding%20another%20person%20painful%20hands%20for%20joint%20care%2C%20warm%20soft%20background%2C%20tender%20health%20care%20concept%2C%20soft%20diffused%20light%2C%20editorial%20photography%2C%20high%20detail&width=640&height=460&seq=disease-04&orientation=landscape',
    symptom: '对称性小关节肿痛、晨僵明显、活动受限，遇冷加重，病程日久可致关节变形。',
    detail: [
      '类风湿关节炎属中医“痹证”，多由风寒湿邪侵袭、经络痹阻所致，治疗强调祛风除湿、通络止痛与扶正固本并重。',
      '平台联合风湿免疫专科，采用中药、针灸、康复训练与规范用药相结合的中西医协同方案，注重长期病情管理与随访。',
    ],
  },
  {
    id: 5,
    name: '2型糖尿病',
    image:
      'https://readdy.ai/api/search-image?query=Clean%20flat%20lay%20of%20fresh%20vegetables%2C%20whole%20grains%20and%20a%20glucometer%20on%20a%20light%20beige%20surface%2C%20soft%20natural%20light%2C%20healthy%20diet%20concept%20editorial%20photography%2C%20high%20detail&width=640&height=460&seq=disease-05&orientation=landscape',
    symptom: '多饮多食多尿、体重下降、乏力倦怠，或伴视物模糊、手足麻木等并发症表现。',
    detail: [
      '糖尿病属中医“消渴”范畴，核心病机为阴虚燥热，病久可累及气阴两虚与血瘀，需整体辨证、分期论治。',
      '平台提供中药调理、饮食运动管理、血糖监测与并发症筛查一体化的中西医结合慢病管理方案，帮助平稳控糖。',
    ],
  },
  {
    id: 6,
    name: '月经不调',
    image:
      'https://readdy.ai/api/search-image?query=Elegant%20arrangement%20of%20dried%20rose%20buds%2C%20red%20dates%20and%20a%20warm%20tea%20cup%20on%20a%20soft%20cream%20surface%2C%20gentle%20feminine%20health%20care%20concept%2C%20soft%20natural%20light%2C%20editorial%20photography&width=640&height=460&seq=disease-06&orientation=landscape',
    symptom: '月经周期紊乱、经量异常、经期腹痛，常伴情绪波动、腰酸乏力等，影响身心健康。',
    detail: [
      '月经不调与肝、脾、肾及冲任二脉功能失调相关，中医按气血虚实辨证，注重调经养血与疏肝理气。',
      '平台联合妇科专家，提供中药调理、针灸艾灸与生活方式指导相结合的个性化方案，帮助恢复规律周期。',
    ],
  },
  {
    id: 7,
    name: '胃痞（慢性胃炎、消化性溃疡）',
    image:
      'https://readdy.ai/api/search-image?query=Warm%20bowl%20of%20dark%20herbal%20decoction%20with%20a%20slice%20of%20ginger%20and%20scattered%20dried%20herbs%20on%20a%20light%20wooden%20table%2C%20clean%20beige%20background%2C%20soft%20natural%20light%2C%20traditional%20Chinese%20medicine%20health%20editorial%20photography%2C%20high%20detail&width=640&height=460&seq=disease-07&orientation=landscape',
    symptom: '胃脘痞塞胀满、隐痛或灼痛、餐后加重、食欲减退，可伴反酸嗳气、恶心，病程反复迁延。',
    detail: [
      '胃痞属中医“痞满”“胃脘痛”范畴，多因饮食不节、情志失调、脾胃虚弱而致中焦气机不利，治疗以健脾和胃、理气消痞为要。',
      '医院推广的中西医结合诊疗方案强调规范辨证分期，配合中药汤剂、穴位贴敷与饮食调养，帮助缓解症状、减少复发。',
    ],
  },
  {
    id: 8,
    name: '痞满（功能性消化不良）',
    image:
      'https://readdy.ai/api/search-image?query=Small%20ceramic%20tea%20cup%20with%20dried%20tangerine%20peel%20and%20herbal%20tea%20leaves%20on%20a%20clean%20cream%20surface%2C%20soft%20morning%20light%2C%20minimal%20oriental%20wellness%20editorial%20photography%2C%20calm%20mood%2C%20high%20detail&width=640&height=460&seq=disease-08&orientation=landscape',
    symptom: '餐后饱胀、早饱、上腹灼热或疼痛、嗳气纳差，检查多无明显器质性病变，与情绪饮食密切相关。',
    detail: [
      '功能性消化不良属中医“痞满”范畴，病位在胃、涉及肝脾，常见肝胃不和、脾胃虚弱等证型。',
      '医院特色方案以疏肝健脾、和胃降逆为法，结合针灸、耳穴与情志调理，改善消化不良症状与生活质量。',
    ],
  },
  {
    id: 9,
    name: '胃痞（胆囊炎、脂肪肝）',
    image:
      'https://readdy.ai/api/search-image?query=Fresh%20vegetables%2C%20whole%20grains%20and%20a%20small%20bowl%20of%20herbal%20tea%20arranged%20on%20a%20light%20beige%20surface%2C%20soft%20natural%20light%2C%20metabolic%20health%20concept%20editorial%20photography%2C%20clean%20composition%2C%20high%20detail&width=640&height=460&seq=disease-09&orientation=landscape',
    symptom: '右上腹胀痛、口苦、脘闷不适，进食油腻后加重，常伴血脂、血糖等代谢指标异常。',
    detail: [
      '本方案针对胆囊炎、脂肪肝等代谢相关疾病，从中医“肝胆脾胃”整体出发，注重疏肝利胆、健脾化湿。',
      '采用中药调理配合饮食运动管理，帮助改善肝功能、减少发作频次，逐步逆转早期代谢异常。',
    ],
  },
  {
    id: 10,
    name: '肝硬化腹水',
    image:
      'https://readdy.ai/api/search-image?query=Porcelain%20bowl%20of%20herbal%20decoction%20with%20a%20wooden%20spoon%20and%20dried%20medicinal%20herbs%20beside%20it%20on%20a%20warm%20wooden%20table%2C%20soft%20natural%20light%2C%20traditional%20medicine%20editorial%20photography%2C%20high%20detail&width=640&height=460&seq=disease-10&orientation=landscape',
    symptom: '腹胀如鼓、腹部膨隆、下肢浮肿、尿少纳差，常伴乏力与消化功能减退。',
    detail: [
      '肝硬化腹水属中医“臌胀”范畴，病机为本虚标实，治疗需兼顾利水消胀与扶正固本。',
      '岳阳医院“三治两防”综合方案配合“水熨贴”外敷及针灸艾灸，实现西医解急症、中医固根本的协同疗效。',
    ],
  },
  {
    id: 11,
    name: '泌尿系统结石',
    image:
      'https://readdy.ai/api/search-image?query=Clear%20glass%20of%20water%20with%20a%20lemon%20slice%20and%20scattered%20herbal%20seeds%20on%20a%20clean%20light%20surface%2C%20soft%20natural%20light%2C%20healthy%20hydration%20concept%20editorial%20photography%2C%20minimal%20composition%2C%20high%20detail&width=640&height=460&seq=disease-11&orientation=landscape',
    symptom: '腰部或腹部阵发性绞痛、血尿、尿频尿急，疼痛可向下腹及会阴部放射。',
    detail: [
      '泌尿系统结石属中医“石淋”范畴，多因湿热蕴结、气滞血瘀所致，治疗以清热利湿、通淋排石为法。',
      '岳阳医院采用“个性化调理湿热体质＋调节尿液酸碱度＋抑制结石再生”的中西医结合疗法，可使结石3年复发率明显下降。',
    ],
  },
  {
    id: 12,
    name: '胸外科围手术期整合治疗',
    image:
      'https://readdy.ai/api/search-image?query=Doctor%20hands%20in%20soft%20light%20arranging%20a%20sprig%20of%20herbs%20beside%20a%20clean%20surgical%20instrument%20on%20a%20warm%20neutral%20surface%2C%20professional%20medical%20concept%20photography%2C%20gentle%20composition%2C%20high%20detail&width=640&height=460&seq=disease-12&orientation=landscape',
    symptom: '胸部手术前后出现的疼痛、咳嗽、气促、乏力，以及麻醉与术后康复相关的一系列不适。',
    detail: [
      '本方案贯穿胸外科手术全程，融合中医针刺麻醉与围手术期中医药干预，强调减毒增效与快速康复。',
      '岳阳医院“术前针刺麻醉降低麻醉风险＋术中精准微创＋术后中医药扶正减毒”的全生命周期整合治疗，显著提升患者疗效与生活质量。',
    ],
  },
  {
    id: 13,
    name: '心力衰竭',
    image:
      'https://readdy.ai/api/search-image?query=Stethoscope%20resting%20beside%20a%20warm%20cup%20of%20herbal%20tea%20and%20red%20dates%20on%20a%20light%20beige%20surface%2C%20soft%20diffused%20light%2C%20cardiovascular%20health%20concept%20editorial%20photography%2C%20high%20detail&width=640&height=460&seq=disease-13&orientation=landscape',
    symptom: '气促乏力、活动后加重、下肢浮肿、夜间不能平卧，常伴心悸、咳嗽与尿量减少。',
    detail: [
      '心力衰竭属中医“心衰”范畴，病机多为心气阳虚、水饮瘀阻，治疗强调益气温阳、活血利水。',
      '广东省中医院中西医结合方案使患者症状改善率达80%-90%，再住院风险降低；益气温阳法治疗急性心肌梗死后主要不良心血管事件风险降低49%，左心室射血分数提高4.8%。',
    ],
  },
  {
    id: 14,
    name: '中风',
    image:
      'https://readdy.ai/api/search-image?query=Gentle%20hands%20supporting%20an%20elderly%20person%20hand%20during%20rehabilitation%2C%20warm%20soft%20neutral%20background%2C%20tender%20health%20care%20concept%20photography%2C%20soft%20diffused%20light%2C%20high%20detail&width=640&height=460&seq=disease-14&orientation=landscape',
    symptom: '突发半身不遂、口舌歪斜、言语不利、偏身麻木，或伴头晕、吞咽困难等神经功能缺损。',
    detail: [
      '中风起病急骤，属中医“中风”范畴，病机可归纳为风、火、痰、瘀、虚，治疗需分期辨证。',
      '广东省中医院建立的慢病管理体系使卒中复发率降至2.88%-3.91%，显著低于全国水平。',
    ],
  },
  {
    id: 15,
    name: '中枢性眩晕',
    image:
      'https://readdy.ai/api/search-image?query=Calm%20minimal%20still%20life%20with%20a%20ceramic%20cup%20and%20a%20small%20sprig%20of%20green%20herbs%20on%20a%20clean%20cream%20surface%2C%20soft%20blurred%20background%2C%20balance%20and%20wellness%20concept%20photography%2C%20high%20detail&width=640&height=460&seq=disease-15&orientation=landscape',
    symptom: '反复发作的头晕目眩、视物旋转、行走不稳，可伴恶心呕吐、耳鸣与平衡障碍。',
    detail: [
      '中枢性眩晕病位在脑，常与脑神失调、浊毒损脑相关，治疗以平肝熄风、化痰通络、醒脑安神为法。',
      '海南医院依托王新陆国医大师学术思想，中药平肝熄风化痰，配合针灸、前庭康复训练，改善眩晕症状，降低复发风险。',
    ],
  },
  {
    id: 16,
    name: '腰椎间盘突出',
    image:
      'https://readdy.ai/api/search-image?query=Person%20gently%20touching%20lower%20back%20with%20both%20hands%2C%20clean%20warm%20neutral%20background%2C%20soft%20studio%20light%2C%20spinal%20health%20and%20wellness%20concept%20photography%2C%20calm%20mood%2C%20high%20detail&width=640&height=460&seq=disease-16&orientation=landscape',
    symptom: '腰部疼痛、下肢放射痛与麻木、活动受限，久坐久站或弯腰后加重。',
    detail: [
      '腰椎间盘突出属中医“腰痛”“痹证”范畴，病机多为肝肾不足、筋骨失养兼风寒湿瘀阻络。',
      '海南医院运用林定坤教授“筋骨平衡”学术思想，采用五阶梯治疗模式，针灸推拿、中药内服外用联合微创/手术，缓解腰腿疼痛，恢复筋骨平衡。',
    ],
  },
  {
    id: 17,
    name: '脑梗死',
    image:
      'https://readdy.ai/api/search-image?query=Walnuts%20and%20a%20warm%20cup%20of%20herbal%20tea%20arranged%20on%20a%20clean%20light%20surface%2C%20soft%20natural%20light%2C%20brain%20wellness%20and%20nutrition%20concept%20editorial%20photography%2C%20minimal%20composition%2C%20high%20detail&width=640&height=460&seq=disease-17&orientation=landscape',
    symptom: '突发言语不清、肢体无力麻木、口角歪斜、行走不稳，严重时可出现意识障碍。',
    detail: [
      '脑梗死属中医“缺血性中风”范畴，急性期以风痰瘀阻为主，治疗强调醒脑开窍、活血通络。',
      '海南医院急性期配合脑脉开合等中医特色技术与西医溶栓、抗凝、抗血小板、早期中药、针灸、康复训练，减轻神经功能缺损，降低致残率。',
    ],
  },
  {
    id: 18,
    name: '腰椎椎管狭窄',
    image:
      'https://readdy.ai/api/search-image?query=Person%20gently%20placing%20both%20hands%20on%20the%20lower%20back%20while%20sitting%2C%20clean%20warm%20neutral%20background%2C%20soft%20studio%20light%2C%20spinal%20health%20and%20wellness%20concept%20photography%2C%20calm%20mood%2C%20high%20detail&width=640&height=460&seq=disease-18&orientation=landscape',
    symptom: '腰腿疼痛、间歇性跛行，行走一段距离后下肢酸胀麻木需蹲下休息，久站或后仰时加重。',
    detail: [
      '腰椎椎管狭窄属中医“痹证”“腰痛”范畴，多因肝肾亏虚、筋骨失养兼风寒湿瘀阻络所致，以中老年人群多见。',
      '武汉中西医结合骨科医院推广的中西医结合诊疗方案以补益肝肾、活血通络为法，保守治疗配合针灸推拿、中药内服外用，必要时行微创减压手术，帮助缓解腰腿疼痛、改善间歇性跛行。',
    ],
  },
  {
    id: 19,
    name: '膝关节病（膝痹）',
    image:
      'https://readdy.ai/api/search-image?query=Close%20up%20of%20hands%20gently%20massaging%20a%20knee%2C%20clean%20warm%20beige%20background%2C%20soft%20studio%20light%2C%20joint%20health%20and%20wellness%20concept%20photography%2C%20calm%20mood%2C%20high%20detail&width=640&height=460&seq=disease-19&orientation=landscape',
    symptom: '膝关节疼痛肿胀、上下楼及蹲起时加重、活动受限，可伴摩擦感与晨僵，遇冷或劳累后加剧。',
    detail: [
      '膝痹多因肝肾不足、筋骨失养，兼风寒湿邪侵袭、痰瘀阻络所致，是以膝部疼痛、屈伸不利为主症的退行性疾病。',
      '医院采用中药内服外用、针灸、针刀与关节功能锻炼相结合的综合诊疗方案，配合阶梯化治疗，帮助缓解疼痛、改善关节功能、延缓病情进展。',
    ],
  },
];

export const achievements = [
  {
    id: 1,
    title: '中药材全流程数智溯源平台落地应用',
    date: '2025-08-12',
    summary: '覆盖种植、加工、流通到临床使用的全链条数智溯源体系，保障中药材质量安全与来源可查。',
    image:
      'https://readdy.ai/api/search-image?query=Modern%20data%20visualization%20screen%20showing%20a%20supply%20chain%20map%20of%20Chinese%20herbs%2C%20green%20and%20warm%20tones%2C%20clean%20tech%20interior%2C%20soft%20light%2C%20professional%20editorial%20photography%2C%20high%20detail&width=720&height=480&seq=achieve-01&orientation=landscape',
    highlights: [
      '覆盖 200+ 道地药材品种，连通 500+ 规范化种植基地',
      '全程区块链上链存证，扫码溯源响应不足 1 秒',
      '已接入 30+ 家三甲医院药事管理与临床系统',
    ],
    detail: [
      '该成果融合物联网、区块链与大数据技术，实现中药材从种植基地到临床使用终端的全流程数字化追溯，让每一味药材都能做到“来源可查、去向可追、责任可究”。',
      '在种植端，平台通过土壤、温湿度与光照传感器实时采集环境数据，结合标准化种植规范，为道地药材建立全生命周期的“数字档案”，从源头保障药材质量稳定。',
      '在流通端，依托区块链不可篡改的特性，将采收、加工、仓储、运输等关键环节逐一上链存证，一旦出现质量问题，可在数秒内精准定位到具体批次与责任主体。',
      '在临床端，平台与医院药事管理系统打通，医师开方时可即时查看药材的产地、批次与质检报告，为合理用药与安全用药提供数据支撑。目前成果已接入多家三甲医院与道地药材产区，为中药质量评价、标准制定与产业协同提供了可复制的数据底座。',
    ],
  },
  {
    id: 2,
    title: '中西医结合慢病管理智能辅助决策系统',
    date: '2025-06-28',
    summary: '将中医辨证与循证医学数据融合，为基层医师提供慢病诊疗路径建议与随访管理支持。',
    image:
      'https://readdy.ai/api/search-image?query=Doctor%20using%20a%20tablet%20with%20a%20health%20data%20dashboard%20in%20a%20bright%20modern%20clinic%2C%20warm%20neutral%20interior%2C%20soft%20light%2C%20professional%20medical%20technology%20photography%2C%20high%20detail&width=720&height=480&seq=achieve-02&orientation=landscape',
    highlights: [
      '覆盖高血压、糖尿病等 12 类常见慢性病',
      '试点机构慢病规范管理率提升至 85%',
      '基层医师诊疗决策效率平均提升 40%',
    ],
    detail: [
      '系统以名老中医经验与临床指南为知识基础，结合患者体征与随访数据，输出个性化的中西医结合干预建议，帮助基层医师在有限条件下也能开展规范化的慢病管理。',
      '在知识层，系统沉淀了数百位名老中医的医案与方剂，构建起结构化的中医辨证知识图谱，将“只可意会”的临床经验转化为可检索、可复用的诊疗知识。',
      '在应用层，基层医师录入患者的四诊信息与检查指标后，系统会实时给出证型判断、治法方药、生活方式建议与随访计划，并随患者病情变化动态调整方案。',
      '在管理层，系统自动汇总辖区慢病人群的健康档案与随访记录，生成管理质量报告，辅助卫生主管部门掌握整体防控态势。目前已在多地社区卫生服务中心试点应用，显著提升了基层慢病管理的规范化水平与服务效率。',
    ],
  },
  {
    id: 3,
    title: '院内制剂标准化研发与成果转化',
    date: '2025-04-15',
    summary: '推动多家医院院内制剂的标准化研究、质量提升与合规转化，让特色制剂更好惠及患者。',
    image:
      'https://readdy.ai/api/search-image?query=Clean%20modern%20pharmaceutical%20laboratory%20with%20herbal%20extract%20bottles%20and%20precise%20equipment%2C%20warm%20neutral%20tones%2C%20soft%20light%2C%20professional%20research%20photography%2C%20high%20detail&width=720&height=480&seq=achieve-03&orientation=landscape',
    highlights: [
      '完成 30+ 个院内制剂的质量标准研究',
      '推动 8 个疗效确切品种进入新药研发管线',
      '成果覆盖心血管、呼吸、骨伤等 6 大领域',
    ],
    detail: [
      '联合药学研究机构与临床医院，对疗效确切的院内制剂开展质量标准、工艺与稳定性研究，推进院内制剂从“经验方”向“标准化产品”的规范化转化。',
      '在质量研究方面，团队建立了涵盖药材基原、有效成分含量、指纹图谱与重金属限量等多项指标的质量标准体系，让院内制剂的质量做到“有标可依、有据可查”。',
      '在转化路径方面，平台打通了从处方筛选、工艺放大、药理验证到注册申报的全链条服务，帮助医院少走弯路，加快特色制剂走向临床与市场的步伐。',
      '目前成果已涵盖心血管、呼吸、骨伤等多个领域，其中多个品种展现出良好的临床价值与转化前景，为中药新药研发与产业落地提供了扎实的前期基础。',
    ],
  },
  {
    id: 4,
    title: '名老中医经验智能化传承平台发布',
    date: '2025-01-20',
    summary: '以知识图谱与人工智能技术沉淀名老中医辨证经验，实现可检索、可复用的活态传承。',
    image:
      'https://readdy.ai/api/search-image?query=Elderly%20Chinese%20medicine%20master%20teaching%20beside%20a%20large%20digital%20screen%20with%20herbal%20knowledge%2C%20warm%20respectful%20atmosphere%2C%20soft%20light%2C%20documentary%20editorial%20photography%2C%20high%20detail&width=720&height=480&seq=achieve-04&orientation=landscape',
    highlights: [
      '收录 500+ 位名老中医、10 万+ 份临床医案',
      '支持智能问答与方剂配伍推荐',
      '累计服务 1000+ 名青年医师与基层机构',
    ],
    detail: [
      '平台系统整理了名老中医的医案、方剂与辨证思路，构建结构化的中医知识图谱，支撑教学、科研与临床辅助，让珍贵的临床经验得以数字化留存。',
      '在数据层，团队对名老中医的原始医案进行结构化标注，抽取症状、证型、治法、方药等要素，形成可检索、可关联的中医知识网络，突破了传统传承中“师带徒、一对一”的时空局限。',
      '在智能层，平台基于知识图谱提供智能问答与方剂配伍推荐，青年医师输入患者证候，即可获得与之相关的名医经验参考与用药思路提示，让学习过程更贴近真实临床。',
      '在传承层，平台通过医案对比、思路解析与模拟辨证等模块，帮助青年医师理解名老中医的诊疗逻辑而非简单“抄方”。目前已有千余名青年医师与基层机构在实际工作中使用，让宝贵经验真正实现了跨越时空的活态传承。',
    ],
  },
];